var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22,
    stroke: "#17110F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 11.5C4 11.1526 4.26863 10.871 4.6 10.871L17.3997 10.871C17.731 10.871 17.9997 11.1526 17.9997 11.5C17.9997 11.8474 17.731 12.129 17.3997 12.129H4.6C4.26863 12.129 4 11.8474 4 11.5ZM6.62646 17.371C6.62646 17.0236 6.89508 16.7419 7.22646 16.7419L17.4 16.7419C17.7314 16.7419 18 17.0236 18 17.371C18 17.7184 17.7314 18 17.4 18L7.22646 18C6.89508 18 6.62646 17.7184 6.62646 17.371ZM11.1775 5.62903C11.1775 5.28163 11.4461 5 11.7775 5L17.4 5C17.7314 5 18 5.28163 18 5.62903C18 5.97644 17.7314 6.25806 17.4 6.25806L11.7775 6.25806C11.4461 6.25806 11.1775 5.97644 11.1775 5.62903Z",
    fill: "#F55539"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.87719614cf1c83e14ced72963dbe3815.svg";
export { ForwardRef as ReactComponent };